import React, { useRef, useEffect } from 'react';

interface Props {
  value: string;
  onChange: (html: string) => void;
}

const buttons = [
  { cmd: 'bold', label: 'B' },
  { cmd: 'italic', label: 'I' },
  { cmd: 'underline', label: 'U' },
  { cmd: 'insertUnorderedList', label: '• Lista' },
  { cmd: 'insertOrderedList', label: '1. Lista' }
];

const RichTextEditor: React.FC<Props> = ({ value, onChange }) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== value) {
      ref.current.innerHTML = value || '';
    }
  }, [value]);

  const exec = (cmd: string, arg?: string) => {
    document.execCommand(cmd, false, arg);
    ref.current && onChange(ref.current.innerHTML);
  };

  const handleInput = () => {
    ref.current && onChange(ref.current.innerHTML);
  };

  const handleImageInsert = () => {
    const url = window.prompt('Bild-URL');
    if (url) {
      exec('insertImage', url);
    }
  };

  return (
    <div>
      <div className="editor-toolbar">
        {buttons.map(btn => (
          <button type="button" key={btn.cmd} onClick={() => exec(btn.cmd)}>{btn.label}</button>
        ))}
        <button type="button" onClick={() => exec('createLink', window.prompt('Länk-URL') || '')}>Länk</button>
        <button type="button" onClick={handleImageInsert}>Bild</button>
        <button type="button" onClick={() => exec('formatBlock', '<h2>')}>H2</button>
        <button type="button" onClick={() => exec('formatBlock', '<p>')}>P</button>
      </div>
      <div
        className="rich-text-editor"
        ref={ref}
        contentEditable
        suppressContentEditableWarning
        onInput={handleInput}
      />
    </div>
  );
};

export default RichTextEditor;
